import React from "react";
import PropTypes from "prop-types";

/**
 * A component that displays an input message.
 * @typedef {Object} CalciteInputMessageProps
 * @property {string} [className] - The class name to apply to the component.
 * @property {string} [icon] - The icon to display in the input message.
 * @property {boolean} [iconFlipRtl] - Whether the icon should flip in RTL.
 * @property {string} [scale] - The scale of the input message.
 * @property {string} [status] - The status of the input message.
 * @property {React.ReactNode} [children] - The children of the component.
 *
 * @param {CalciteInputMessageProps} props
 * @returns {JSX.Element}
 *
 * @example
 * <CalciteInputMessage icon="info" status="valid">
 *  This is a valid message.
 * </CalciteInputMessage>
 */
const CalciteInputMessage = ({ className, icon, iconFlipRtl, scale, status, children, ...rest }) => {
  return (
    <calcite-input-message
      class={className}
      icon={icon || undefined}
      icon-flip-rtl={iconFlipRtl == null ? undefined : iconFlipRtl}
      scale={scale || undefined}
      status={status || undefined}
      {...rest}
    >
      {children}
    </calcite-input-message>
  );
};

PropTypes.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  iconFlipRtl: PropTypes.bool,
  scale: PropTypes.oneOf(["s", "m", "l"]),
  status: PropTypes.oneOf(["idle", "valid", "invalid"]),
  children: PropTypes.node,
};

export default CalciteInputMessage;
